export default __webpack_public_path__ + "static/media/img-time-km-uk_en@3x.23932916.png";